angular.
module("dx.webapp.examParts").
constant("DX_EXAM_PARTS", (function iife() {
	"use strict";

	var examParts = {
		NONE: 0,
		EXAM_TITLE: 1 << 0,
		EXAM_START_DATE: 1 << 1,
		EXAM_DESCRIPTION: 1 << 2,
		EXAM_ACCESSIBILITY_SETTINGS: 1 << 3,
		EXAM_GRADING_MATRIX: 1 << 4,
		EXAM_PROFILE_PICTURE: 1 << 5,

		QUESTION_TITLE: 1 << 9,
		QUESTION_DESCRIPTION: 1 << 10,
		QUESTION_ATTACHMENT: 1 << 11,
		QUESTION_ALTERNATIVE: 1 << 12,
		QUESTION_ALTERNATIVE_CORRECT: 1 << 13,
		QUESTION_ONLINE_RESOURCES: 1 << 14,

		ANSWER_DATA: 1 << 19,
		ANSWER_ATTACHMENT: 1 << 20,
		ANSWER_TEACHER_NOTE: 1 << 21,
		ANSWER_FORMATIVE_ASSESSMENT: 1 << 22,
		ANSWER_ANNOTATIONS: 1 << 23,
		ANSWER_GRADE: 1 << 24,
		ANSWER_WORD_COUNT: 1 << 25,

		FINAL_GRADE: 1 << 29,
		FINAL_TEACHER_NOTE: 1 << 30,

		ALL_PARTS: 0x7FFFFFFF,
	};

	examParts.ALL_QUESTION_PARTS = (examParts.QUESTION_TITLE | examParts.QUESTION_DESCRIPTION | examParts.QUESTION_ATTACHMENT |
		examParts. QUESTION_ALTERNATIVE | examParts.QUESTION_ALTERNATIVE_CORRECT | examParts.QUESTION_ONLINE_RESOURCES); // 0x7e00

	examParts.ALL_ANSWER_PARTS = (examParts.ANSWER_DATA | examParts.ANSWER_ATTACHMENT | examParts.ANSWER_TEACHER_NOTE |
		examParts.ANSWER_FORMATIVE_ASSESSMENT | examParts.ANSWER_ANNOTATIONS | examParts.ANSWER_GRADE | examParts.ANSWER_WORD_COUNT); // 0x3f80000

	examParts.EXAM_PRINT_PARTS = (examParts.EXAM_TITLE | examParts.EXAM_START_DATE | examParts.EXAM_DESCRIPTION | examParts.EXAM_ACCESSIBILITY_SETTINGS |
		examParts.QUESTION_TITLE | examParts.QUESTION_DESCRIPTION | examParts.QUESTION_ATTACHMENT |
		examParts.QUESTION_ALTERNATIVE | examParts.QUESTION_ONLINE_RESOURCES);

	return Object.freeze(examParts);
}()));
